import {
  Form, Formik, FormikProps, getIn,
} from 'formik';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISendComercialForm } from './ISendComercialForm';
import Button from 'components/base/Button';
import { Row } from 'components/base/Row';
import Textarea from 'components/base/Textarea';
import { useArticles } from 'hooks/useArticles';
import { useRecord } from 'hooks/useRecord';
import { useEmailFormValidation } from 'modules/budget/components/tracking/EmailForm/validation';

export const SendComercialForm: FC<ISendComercialForm> = ({ erpId }) => {
  const { t } = useTranslation();
  const { validate } = useEmailFormValidation();
  const { sendComercialPdf } = useArticles();
  const { getInfo } = useRecord();
  const [email, setEmail] = useState<string>('');

  useEffect(
    () => {
      if (erpId) {
        getInfo(Number(erpId))
          .then((response) => {
            if (response.declarantEmail) {
              setEmail(response.declarantEmail);
            }
            return response;
          })
          .catch(() => false);
      }
    },
    [erpId, getInfo],
  );

  return (
    <Formik
      initialValues={{
        email,
      }}
      isInitialValid={!!email}
      validationSchema={validate}
      enableReinitialize
      validateOnChange
      onSubmit={(values, { resetForm }) => {
        sendComercialPdf(erpId, values.email)
          .then((r) => {
            setEmail('');
            return r;
          })
          .catch(() => false);
        resetForm();
      }}
    >
      {({
        errors, handleBlur, setFieldValue, values, isValid,
      }: FormikProps<{
        email: string;
      }>) => (
        <React.Fragment>
          <Form autoComplete="off" className="f-send-comercial-form">
            <Row>
              <Textarea
                error={getIn(errors, 'email')}
                id="email"
                name="email"
                placeholder={t('common.email')}
                rightAddon={(
                  <Button
                    color="primary"
                    disabled={!isValid}
                    text={t('common.send')}
                    type="submit"
                  />
                )}
                value={values.email}
                onBlur={handleBlur}
                onChange={(val) => setFieldValue('email', val)}
              />

            </Row>
          </Form>
        </React.Fragment>
      )}
    </Formik>
  );
};
